import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { redirectTo } from '../../helpers/url'

import { getCurrentUserSelector } from '../../modules/selectors/app'

import { ROUTES } from '../../constants/routes'

export default function useUserHaveInvites(redirectToInvites) {
  const user = useSelector(getCurrentUserSelector)

  const { account_invites: accountInvites } = user
  const hasInvites = accountInvites && !!accountInvites.length

  useEffect(() => {
    if (hasInvites && redirectToInvites) {
      redirectTo(ROUTES.invites)
    }
  }, [hasInvites, redirectToInvites])

  return hasInvites
}
